module.exports = __webpack_public_path__ + "static/media/portfolio-cover.c83e147d.png";